<template>
  <div class="course-content" v-loading="!data">
    <template v-if="data">
      <div class="container content">
        <el-breadcrumb class="breadcrumb pc" separator=">">
          <el-breadcrumb-item :to="{ path: '../../portal' }">
            <i class="iconfont iconyemiandaohang-shouye"></i>首页
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '../../courses/' + declareType }">{{ declareTypeNavMap[declareType] }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ data.name }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="card">
          <el-image class="cover" fit="cover" v-if="data.cover" :src="buildResourcePath(data.cover)">
            <div slot="error" class="default-img">
              <i class="iconfont iconjiaocaizhanwei"></i>
            </div>
          </el-image>
          <div v-if="!data.cover" class="cover">
            <div class="default-img">
              <i class="iconfont iconjiaocaizhanwei"></i>
            </div>
          </div>
          <div class="info">
            <h1>{{ data.name }}</h1>
            <div class="info-item">认定类型：{{ declareTypeMap[declareType] }}</div>
            <div class="info-item">认定级别/年份：<span v-for="affItem in data.affirmCourseList" :key="affItem.id">{{ levelMap[affItem.level] + " (" + affItem.grade + ")" }}</span></div>
            <div class="info-item">申报学校：{{ data.orgName }}</div>
            <div class="info-item">课程负责人：{{ data.masterName }}</div>
            <div class="info-item">课程团队主要成员：{{ data.courseTeam ? data.courseTeam : data.masterName }}</div>
            <div class="info-item" v-if="data.studyUrl">
              <el-button class="study" type="primary" @click="study(data)">现在去学习</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="grey-bg">
        <div class="container content">
          <div class="course-content-1" v-if="declareType == 1">
            <div class="content-block" v-if="data.onlineCourse">
              <h1>课程简介</h1>
              <div class="content-desc" v-html="data.onlineCourse.intro"></div>
            </div>
          </div>
          <div class="course-content-1" v-if="declareType == 3">
            <div class="content-block" v-if="data.onlineCourse">
              <h1>使用的在线课程</h1>
              <div class="latest-issue">
                <el-row :gutter="32">
                  <el-col :sm="10" class="issue-item">课程名称：{{ data.onlineCourse.name }}</el-col>
                  <el-col :sm="14" class="issue-item">课程平台：{{ data.onlineCourse.platformName }}</el-col>
                  <el-col :sm="10" class="issue-item">课程学校：{{ data.onlineCourse.orgName }}</el-col>
                  <el-col :sm="14" class="issue-item">课程教师：{{ data.onlineCourse.teacher }}</el-col>
                </el-row>
                <el-button class="view-detail" type="danger" size="small" @click="viewDetail(data.onlineCourse.url)" >查看详情</el-button>
              </div>
            </div>
            <div class="content-block" v-if="data.applicationMaterial">
              <h1>课程目标</h1>
              <div class="content-desc" v-text="data.applicationMaterial.courseGoal"></div>
            </div>
          </div>
          <div class="course-content-1" v-if="declareType == 2 || declareType == 4">
            <div class="content-block" v-if="data.applicationMaterial">
              <h1>课程目标</h1>
              <div class="content-desc" v-text="data.applicationMaterial.courseGoal"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { spocCourseContent } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "courseContent",
  props: ["declareType", "id"],
  data() {
    return {
      data: {},
      declareTypeNavMap: {
        1: "线上课程",
        3: "混合式课程",
        4: "社会实践课程",
        5: "虚拟仿真课程",
        2: "线下课程",
      },
      declareTypeMap: {
        1: "线上一流课程",
        3: "线上线下混合式一流课程",
        4: "社会实践一流课程",
        5: "虚拟仿真一流课程",
        2: "线下一流课程",
      },
      levelMap: {
        1: "国家级",
        2: "省级",
        3: "校级",
      }
    };
  },
  created() {
    spocCourseContent({
        declareType: this.declareType,
        id: this.id
      })
      .then(res => {
        // 返回数据
        this.data = res;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    study(data) {
      window.open(data.studyUrl)
    },
    viewCourse() {
      // 判断登录状态
      let userInfo = util.getCookie("USER_INFO");
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
      }

      if (userInfo && userInfo.userId) {
        window.open(
          "https://www.ulearning.cn/ulearning/index.html#/joinCourse/spoc"
        );
      } else {
        this.$message({
          showClose: true,
          message: "请先登录",
          type: "warning"
        });
      }
    },
    viewDetail(url) {
      if(url){
        window.open(url);
      }
    },
    buildResourcePath: util.buildResourcePath,
    timeFormat(value) {
      return util.timeFormat(value, "yyyy年MM月dd日");
    },
    timeFormatHH(value) {
      return util.timeFormat(value, "yyyy年MM月dd日 hh:mm");
    }
  }
};
</script>

<style scoped>
.study {
  background-color: #7691ff;
  border-color: #7691ff;
}
.study:hover {
  color: #7691ff;
  background-color: #e9ecfc;
  border-color: #e9ecfc;
}
.study:active {
  background-color: #7691ff;
  border-color: #7691ff;
  color: #fff;
}
.breadcrumb {
  margin: 10px 0;
}

.breadcrumb .iconfont {
  margin-right: 2px;
  font-size: 14px;
}
.content {
  margin-top: 20px;
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 10px;
}

.card {
  position: relative;
  padding: 10px 0;
  background-color: #fff;
}

.card .cover {
  position: absolute;
  width: 440px;
  height: 225px;
  background-color: #eee;
}

.card .info {
  min-height: 203px;
  padding-left: 490px;
}

.card h1 {
  margin-bottom: 20px;
  line-height: 42px;
  font-size: 30px;
  overflow: hidden;
}

.card .info-item {
  margin-bottom: 10px;
  line-height: 22px;
  font-size: 14px;
}

.card .view-btn {
  margin-top: 48px;
  width: 224px;
}

.grey-bg{
  min-height: calc(100vh - 675px);
  padding-top: 10px;
  padding-bottom: 30px;
  background-color: #f7f7fe;
}

/* .row {
  margin-top: 20px;
} */

.course-content-1 {
  padding: 30px 50px;
  background-color: #fff;
  border: 1px solid #dedef5;
}

.course-content-1 h1 {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
  line-height: 28px;
  font-size: 20px;
  color: #111;
}
.course-content-1 h1::before{
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  z-index: 0;
  content: ' ';
  display: block;
  height: 4px;
  background: rgba(118,145,255,0.20);
}

.course-content-1 h2 {
  margin: 20px 0 10px 0;
  padding: 0 18px;
  line-height: 38px;
  font-size: 16px;
  color: #ff8700;
  background-color: rgba(255, 175, 42, 0.1);
}

.content-block {
  margin-bottom: 40px;
}

.latest-issue{
  position: relative;
  padding: 12px 150px 12px 30px;
  line-height: 36px;
  font-size: 14px;
  background-color: #f7f7fe;
  border: 1px solid #e7e7f8;
}
.latest-issue .status{
  display: inline-block;
  padding: 2px 8px;
  margin-left: 20px;
  line-height: 17px;
  font-size: 12px;
  background-color: #76BD63;
  color: #fff;
  border-radius: 4px;
}
.latest-issue .view-detail{
  position: absolute;
  top: 50%;
  right: 30px;
  margin-top: -18px;
  line-height: 18px;
  padding: 8px 16px;
}
.latest-issue .issue-item{
  line-height: 30px;
}
.content-desc{
  font-size: 14px;
  color: #111;
  line-height: 26px;
}
.content-video{
  position: relative;
  width: 500px;
  height: 280px;
}
.video-mask{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, .3);
}
.video-mask .video-btn{
  width: 156px;
  height: 45px;
  margin: 116px auto;
  text-align: center;
  line-height: 44px;
  font-size: 18px;
  border-radius: 24px;
  background-color: #fff;
  color: #111;
  font-weight: bold;
  cursor: pointer;
}
.video-mask .video-btn i{
  font-size: 22px;
  vertical-align: middle;
  margin-right: 3px;
}
.record-item{
  position: relative;
  height: 110px;
}
.video-mask .play-btn{
  width: 30px;
  height: 30px;
  margin: 40px auto;
  text-align: center;
  line-height: 30px;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, .86);
  color: #111;
  cursor: pointer;
}
.video-mask .play-btn i{
  font-size: 20px;
  vertical-align: middle;
}

.block-tip {
  margin-left: 20px;
  font-size: 14px;
  font-weight: normal;
  color: #888;
  vertical-align: bottom;
}

.empty-tip-1 {
  font-size: 14px;
  color: #888;
}

.content-item .iconfont,
.content-item .content-info {
  display: inline-block;
  vertical-align: top;
}

.content-item .content-info {
  margin-left: -22px;
  padding-left: 22px;
  width: 100%;
  box-sizing: border-box;
}

.content-item {
  padding: 10px 0;
  border-top: 1px solid #e9e9e9;
}

.content-item.first {
  border-top: unset;
}

.content-item .iconfont {
  margin-right: 10px;
  font-size: 12px;
  line-height: 20px;
  color: #e3e3e3;
}

.content-info .name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  overflow: hidden;
}

.content-info .info {
  margin-top: 6px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #888;
  overflow: hidden;
}

.teacher-list {
  margin-bottom: -20px;
}

.teacher-item {
  margin-bottom: 20px;
}

.teacher-item .cover {
  margin-right: 10px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background-color: #eee;
  vertical-align: middle;
  overflow: hidden;
}

.teacher-item .name {
  line-height: 20px;
}

@media (max-width: 767px) {
  .content {
    margin-top: 15px;
    margin-bottom: 30px;
  }

  .card {
    padding: 0;
  }

  .card .cover {
    position: unset;
    width: 100%;
  }

  .card .info {
    min-height: unset;
    padding-left: 0;
  }

  .card h1 {
    margin-top: 16px;
    margin-bottom: unset;
    line-height: 24px;
    font-size: 18px;
    overflow: unset;
  }

  .card .info-item {
    margin-top: 12px;
    display: block;
    width: unset;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
  }

  .course-content-1 h1 {
    font-size: 16px;
  }


  .course-content-1 {
    padding: 15px;
  }

  .latest-issue{
    position: relative;
    padding: 12px;
    line-height: 36px;
    font-size: 14px;
    background-color: #f7f7fe;
    border: 1px solid #e7e7f8;
  }
  .latest-issue .view-detail{
    position: static;
    margin-top: 6px;
  }

}
</style>
